import i18n from 'asset/translation';
import gtmIds from 'adapter/in/dashboards/config/gtm';

type DropdownContent = {
    text: string;
    icon: string;
    dataId: string;
    onClick: (event: Event) => void;
};

export const getActionsDropdownContent = (
    onEdit?: () => void,
    onDelete?: () => void,
    onLink?: () => void,
    onShare?: () => void,
    onPin?: () => void,
    onUnpin?: () => void,
    onDuplicate?: () => void
): DropdownContent[] => {
    const content = [];

    if (onEdit) {
        content.push(buildEdit(onEdit));
    }

    if (onDuplicate) {
        content.push(buildDuplicate(onDuplicate));
    }

    if (onLink) {
        content.push(buildLink(onLink));
    }

    if (onShare) {
        content.push(buildShare(onShare));
    }

    if (onPin) {
        content.push(buildPin(onPin));
    }
    if (onUnpin) {
        content.push(buildUnpin(onUnpin));
    }

    if (onDelete) {
        content.push(buildDelete(onDelete));
    }

    return content;
};

const buildEdit = (onEdit: () => void) => ({
    text: i18n.t('common.edit'),
    icon: 'edit',
    dataId: gtmIds.dashboard.actions.edit,
    onClick: (event: Event) => {
        event.preventDefault();
        onEdit();
    },
});

const buildLink = (onLink: () => void) => ({
    text: i18n.t('common.link'),
    icon: 'link',
    dataId: gtmIds.dashboard.actions.link,
    onClick: (event: Event) => {
        event.preventDefault();
        onLink();
    },
});

const buildDelete = (onDelete: () => void) => ({
    text: i18n.t('common.delete'),
    icon: 'delete',
    dataId: gtmIds.dashboard.actions.delete,
    onClick: (event: Event) => {
        event.preventDefault();
        onDelete();
    },
});

const buildShare = (onShare: () => void) => ({
    text: i18n.t('common.share'),
    icon: 'share',
    dataId: gtmIds.dashboard.actions.share,
    onClick: (event: Event) => {
        event.preventDefault();
        onShare();
    },
});

const buildPin = (onPin: () => void) => ({
    text: i18n.t('dashboards.pinned.action.pin'),
    icon: 'push_pin',
    dataId: gtmIds.dashboard.actions.pin,
    onClick: (event: Event) => {
        event.preventDefault();
        onPin();
    },
});

const buildUnpin = (unPin: () => void) => ({
    text: i18n.t('dashboards.pinned.action.unpin'),
    icon: 'push_pin_off',
    dataId: gtmIds.dashboard.actions.unpin,
    onClick: (event: Event) => {
        event.preventDefault();
        unPin();
    },
});

const buildDuplicate = (onDuplicate: () => void) => ({
    text: i18n.t('common.duplicate'),
    icon: 'duplicate',
    dataId: gtmIds.dashboard.actions.duplicate,
    onClick: (event: Event) => {
        event.preventDefault();
        onDuplicate();
    },
});
